import { useEffect } from 'react';

function useOutsideClick(elementId, callback) {
    useEffect(() => {
        const ref = document.getElementById(elementId);
        function handleClickOutside(event) {
            if (ref && !ref.contains(event.target)) {
                callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [elementId, callback]);
}

export default useOutsideClick;
